import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  text: '',
}

export const validateAdditionalTitle = (active, state) => ({
  text: active && state.text === '' && '추가제목을 입력하세요.',
})

export const getAdditionalTitleAssetData = ({ text }) => ({
  type: 'ADDITIONAL_TITLE',
  data: {
    text,
  },
})

const additionalTitleSlice = createSlice({
  name: 'additionalTitle',
  initialState,
  reducers: {
    reset: () => initialState,
    setText: (state, { payload: text }) => {
      state.text = text
    },
    setAdditionalTitle: (state, { payload: { text } }) => {
      state.text = text
    },
  },
})

export const { reset, setText, setAdditionalTitle } =
  additionalTitleSlice.actions

export default additionalTitleSlice.reducer
